function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

window.AcYouTubeApi = (() => {
  let pending;

  const load = () => {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (pending) return pending;

    let resolveAttempt;
    let rejectAttempt;
    const attempt = new Promise((resolve, reject) => {
      resolveAttempt = resolve;
      rejectAttempt = reject;
    });
    pending = attempt;

    const existing = document.querySelector('script[data-ac-youtube-api], script[src="https://www.youtube.com/iframe_api"]');
    const script = existing || document.createElement('script');
    const previousReady = window.onYouTubeIframeAPIReady;
    let settled = false;
    let timeout;

    const finish = (error) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      script.removeEventListener('error', onError);
      if (window.onYouTubeIframeAPIReady === onReady) {
        window.onYouTubeIframeAPIReady = previousReady;
      }
      if (error) {
        if (!existing) script.remove();
        pending = undefined;
        rejectAttempt(error);
      } else {
        resolveAttempt(window.YT);
      }
    };
    const onError = () => finish(new Error('YouTube API unavailable'));
    const onReady = () => {
      try {
        previousReady?.();
      } finally {
        finish(window.YT?.Player ? null : new Error('YouTube API did not initialize'));
      }
    };

    window.onYouTubeIframeAPIReady = onReady;
    script.addEventListener('error', onError, { once: true });
    timeout = window.setTimeout(() => finish(new Error('YouTube API timed out')), 15000);
    if (!existing) {
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      script.dataset.acYoutubeApi = 'true';
      document.head.append(script);
    }
    return attempt;
  };

  return { load };
})();

function pauseAllMedia() {
  for (const media of document.querySelectorAll('deferred-media')) media.pauseMedia();
  for (const video of document.querySelectorAll('video')) {
    if (!video.closest('deferred-media')) video.pause();
  }
  for (const model of document.querySelectorAll('product-model')) {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && !this.layerManager) this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && event.target === this) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    const section = this.closest('.shopify-section');
    if (section) this.dataset.section = section.id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  disconnectedCallback() {
    if (!this.isConnected) this.hide();
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    this.layerManager = window.AcLayerManager;
    if (this.layerManager) {
      this.layerManager.acquire(this.id, {
        opener,
        getFocusRoots: () => [this],
        onEscape: () => this.hide(),
      });
      this.querySelector('[id^="ModalClose-"]')?.focus({ preventScroll: true });
    } else {
      document.body.classList.add('overflow-hidden');
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    window.pauseAllMedia();
  }

  hide() {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    if (this.layerManager) {
      this.layerManager.release(this.id, { restoreFocus: this.isConnected && this.openedBy?.isConnected });
    } else {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.isConnected ? this.openedBy : null);
    }
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.generation = 0;
    this.onPosterClick = () => this.loadContent();
    this.onSuspend = () => this.pauseMedia();
    this.onVimeoMessage = (event) => {
      const frame = this.querySelector('iframe.js-vimeo');
      if (!frame || event.source !== frame.contentWindow || event.origin !== new URL(frame.src).origin) return;
      let data = event.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (error) { return; }
      }
      if (data?.event !== 'ready' && data?.method !== 'ping') return;
      if (this.vimeoReady) return;
      this.vimeoReady = true;
      this.playMedia();
    };
    this.onPreference = () => {
      if (document.hidden || this.isReduced()) this.pauseMedia();
    };
  }

  connectedCallback() {
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.feedback = this.querySelector('[data-ac-youtube-feedback]');
    this.retry = this.feedback?.querySelector('[data-ac-youtube-retry]');
    this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.poster?.addEventListener('click', this.onPosterClick);
    this.retry?.addEventListener('click', this.onPosterClick);
    this.preference.addEventListener('change', this.onPreference);
    this.motionObserver = new MutationObserver(this.onPreference);
    this.motionObserver.observe(document.body, { attributes: true, attributeFilter: ['data-ac-motion'] });
    document.addEventListener('visibilitychange', this.onPreference);
    window.addEventListener('pagehide', this.onSuspend);
    window.addEventListener('message', this.onVimeoMessage);
    this.classList.add('is-enhanced');
    this.showFailure(false);
  }

  disconnectedCallback() {
    this.poster?.removeEventListener('click', this.onPosterClick);
    this.retry?.removeEventListener('click', this.onPosterClick);
    this.preference?.removeEventListener('change', this.onPreference);
    this.motionObserver?.disconnect();
    document.removeEventListener('visibilitychange', this.onPreference);
    window.removeEventListener('pagehide', this.onSuspend);
    window.removeEventListener('message', this.onVimeoMessage);
    this.resetPlayer();
    this.classList.remove('is-enhanced');
    this.showFailure(false);
    if (this.feedback) this.feedback.hidden = false;
    if (this.retry) this.retry.hidden = true;
  }

  isReduced() {
    return document.body.dataset.acMotion === 'reduced' || this.preference.matches;
  }

  canPlay() {
    return this.requestedPlay && !document.hidden && (this.manualPlay || !this.isReduced());
  }

  pauseMedia() {
    this.requestedPlay = false;
    if (this.ready) this.player?.pauseVideo();
    this.querySelector('video')?.pause();
    const vimeo = this.querySelector('iframe.js-vimeo');
    if (vimeo && this.vimeoReady) vimeo.contentWindow?.postMessage({ method: 'pause' }, new URL(vimeo.src).origin);
    this.modelViewerUI?.pause();
  }

  playMedia() {
    if (!this.canPlay()) return;
    if (this.ready) this.player?.playVideo();
    this.querySelector('video')?.play().catch(() => {});
    const vimeo = this.querySelector('iframe.js-vimeo');
    if (vimeo && this.vimeoReady) vimeo.contentWindow?.postMessage({ method: 'play' }, new URL(vimeo.src).origin);
  }

  showFailure(failed) {
    this.failed = failed;
    this.classList.toggle('is-unavailable', failed);
    if (this.poster) this.poster.disabled = failed && Boolean(this.feedback);
    if (!this.feedback) return;
    this.feedback.hidden = !failed;
    this.retry.hidden = false;
    const status = this.feedback.querySelector('[data-ac-youtube-status]');
    status.textContent = failed ? status.dataset.message : '';
  }

  resetPlayer() {
    this.generation += 1;
    this.pauseMedia();
    this.ready = false;
    this.vimeoReady = false;
    clearTimeout(this.readyTimer);
    clearTimeout(this.styleTimer);
    this.player?.destroy();
    this.player = null;
    this.querySelector(':scope > video, :scope > iframe')?.remove();
    if (!this.querySelector(':scope > model-viewer')) this.removeAttribute('loaded');
  }

  async connectYouTube(frame, generation) {
    const current = () => this.isConnected && this.generation === generation;
    const fail = () => {
      if (!current()) return;
      const restoreFocus = this.contains(document.activeElement);
      this.resetPlayer();
      this.showFailure(true);
      if (restoreFocus) (this.retry || this.poster)?.focus();
    };
    try {
      const api = await window.AcYouTubeApi.load();
      if (!current()) return;
      this.readyTimer = window.setTimeout(fail, 20000);
      this.player = new api.Player(frame, { events: {
        onReady: () => {
          if (!current()) return;
          clearTimeout(this.readyTimer);
          this.ready = true;
          this.playMedia();
        },
        onError: fail,
      } });
    } catch (error) {
      fail();
    }
  }

  loadContent(focus = true) {
    if (!this.isConnected || (this.failed && focus === false)) return;
    window.pauseAllMedia();
    this.manualPlay = focus !== false;
    this.requestedPlay = true;
    if (this.hasAttribute('loaded')) {
      this.playMedia();
      if (focus) this.querySelector('video, model-viewer, iframe')?.focus();
      return;
    }
    const element = this.querySelector('template')?.content.querySelector('video, model-viewer, iframe')?.cloneNode(true);
    if (!element) return;
    this.showFailure(false);
    const youtube = element.matches('iframe.js-youtube');
    if (youtube || element.matches('iframe.js-vimeo')) {
      const url = new URL(element.src);
      url.searchParams.set('autoplay', '0');
      if (youtube) {
        url.searchParams.set('enablejsapi', '1');
        url.searchParams.set('origin', window.location.origin);
      }
      element.src = url.href;
    }
    if (element.nodeName === 'VIDEO') element.removeAttribute('autoplay');
    if (element.matches('iframe.js-vimeo')) {
      this.vimeoReady = false;
      element.addEventListener('load', () => {
        if (this.isConnected && element.parentElement === this) {
          element.contentWindow?.postMessage({ method: 'ping' }, new URL(element.src).origin);
        }
      }, { once: true });
    }
    this.setAttribute('loaded', 'true');
    this.append(element);
    if (focus) element.focus();
    if (youtube) this.connectYouTube(element, ++this.generation);
    else this.playMedia();
    const formerStyle = element.getAttribute('style');
    element.style.display = 'block';
    this.styleTimer = window.setTimeout(() => {
      if (formerStyle === null) element.removeAttribute('style');
      else element.setAttribute('style', formerStyle);
    }, 0);
  }
}

customElements.define('deferred-media', DeferredMedia);

